import React from 'react';

function RemainingThumbnails({ quantity, viewClass }) {
  return (
    <>
      <li className="list-inline-item">
        <div className={`border-0 remaining-quantity d-flex align-items-center justify-content-center remaining-${viewClass}`}>
        +{quantity}
        </div>
      </li>
    </>
  )
}

export default RemainingThumbnails;

